<template>
  <div class="footer">
    <div class="footer-stripes" />
    <div class="footer-wrapper">
      <div class="container">
        <div class="content-wrapper">
          <div class="afripods-logo" />
          <div class="separator" />
          <div class="sitemap">
            <div class="heading">Connect With Us</div>
            <div class="nav-items-wrapper">
              <RouterLink :to="{ path: '/about' }" class="sitemap__link" tag="li"><a>About us</a></RouterLink>
              <RouterLink :to="{ path: '/become_advertiser' }" class="sitemap__link" tag="li"
                ><a>Advertising</a></RouterLink
              >
              <a class="sitemap__link" href="mailto:contactus@afripods.com?subject=Contact Us">Contact Us</a>
              <RouterLink :to="{ path: '/help' }" class="sitemap__link" tag="li"><a>Help</a></RouterLink>
            </div>
          </div>
          <LoginButton v-if="!userLoggedIn" class="hide-on-desktop btn-black login-button" />
          <div class="social-icons">
            <a class="social-icon-link" href="https://www.facebook.com/afripods" rel="external"
              ><i class="icon-facebook" /><span class="sr-only">Facebook</span></a
            >
            <a class="social-icon-link" href="https://instagram.com/afripods" rel="external"
              ><span class="sr-only">Instagram</span><i class="icon-instagram"
            /></a>

            <a class="social-icon-link" href="https://twitter.com/Afripods" rel="external">
              <span class="sr-only">Twitter</span>
              <i class="icon-twitter">
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="twitter-icon"
                >
                  <circle cx="24" cy="24" r="24" fill="white" />
                  <g clip-path="url(#clip0_14618_14390)">
                    <path
                      d="M27.0333 22.3857L35.9678 12H33.8506L26.0927 21.0177L19.8966 12H12.75L22.1198 25.6364L12.75 36.5274H14.8673L23.0598 27.0044L29.6034 36.5274H36.75L27.0333 22.3857ZM24.1333 25.7566L23.1839 24.3987L15.6302 13.5939H18.8823L24.9782 22.3137L25.9276 23.6716L33.8516 35.006H30.5995L24.1333 25.7566Z"
                      fill="#222222"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_14618_14390">
                      <rect width="24" height="24.54" fill="white" transform="translate(12 12)" />
                    </clipPath>
                  </defs>
                </svg>
              </i>
            </a>
          </div>

          <div class="store-icons">
            <a class="store-icon" href="https://apps.apple.com/se/app/afripods/id1242318633?l=en"
              ><span class="sr-only">Afripods on the Apple App Store</span>
              <svg height="35" width="117" xmlns="http://www.w3.org/2000/svg">
                <path
                  class="store-icon-background"
                  d="M112.667 0H4.333A4.366 4.366 0 0 0 0 4.375v26.25A4.366 4.366 0 0 0 4.333 35h108.334A4.366 4.366 0 0 0 117 30.625V4.375A4.366 4.366 0 0 0 112.667 0"
                />
                <path
                  class="store-icon-content"
                  d="M26.91 17.306c.02-1.466.79-2.82 2.042-3.589a4.39 4.39 0 0 0-3.46-1.864c-1.454-.153-2.866.869-3.606.869-.757 0-1.902-.853-3.128-.829a4.609 4.609 0 0 0-3.876 2.358c-1.676 2.894-.425 7.146 1.18 9.485.804 1.145 1.742 2.425 2.971 2.38 1.201-.05 1.651-.764 3.103-.764 1.437 0 1.858.763 3.112.735 1.29-.02 2.101-1.15 2.877-2.307a9.49 9.49 0 0 0 1.317-2.671 4.136 4.136 0 0 1-2.53-3.803M24.543 10.315a4.212 4.212 0 0 0 .967-3.017 4.302 4.302 0 0 0-2.78 1.434 4.003 4.003 0 0 0-.99 2.905 3.553 3.553 0 0 0 2.804-1.322M38.429 21.875h3.252l-1.602-4.707h-.045Zm3.677 1.339h-4.102l-.986 2.9h-1.736l3.885-10.729h1.806l3.885 10.732H43.09ZM51.595 22.205c0-1.583-.821-2.625-2.074-2.625-1.23 0-2.058 1.063-2.058 2.625 0 1.576.828 2.632 2.058 2.632 1.253 0 2.074-1.034 2.074-2.632m1.655 0c0 2.432-1.306 3.995-3.274 3.995a2.663 2.663 0 0 1-2.47-1.37h-.037v3.876H45.86V18.293h1.56v1.301h.03a2.785 2.785 0 0 1 2.498-1.385c1.993 0 3.305 1.569 3.305 3.994M60.23 22.205c0-1.583-.82-2.625-2.073-2.625-1.23 0-2.058 1.063-2.058 2.625 0 1.576.828 2.632 2.058 2.632 1.253 0 2.074-1.034 2.074-2.632m1.655 0c0 2.432-1.306 3.995-3.274 3.995a2.663 2.663 0 0 1-2.47-1.37h-.037v3.876h-1.609V18.293h1.56v1.301h.03a2.786 2.786 0 0 1 2.498-1.385c1.993 0 3.305 1.569 3.305 3.994M67.594 23.127c.119 1.065 1.156 1.763 2.573 1.763 1.358 0 2.334-.7 2.334-1.659 0-.832-.588-1.331-1.984-1.677l-1.395-.335c-1.974-.475-2.892-1.397-2.892-2.892 0-1.851 1.618-3.124 3.916-3.124 2.274 0 3.832 1.273 3.885 3.124h-1.627c-.097-1.071-.984-1.718-2.283-1.718s-2.184.656-2.184 1.604c0 .758.567 1.205 1.954 1.547l1.186.291c2.208.522 3.126 1.407 3.126 2.975 0 2.008-1.604 3.266-4.155 3.266-2.388 0-3.999-1.228-4.104-3.17ZM77.678 16.441v1.852h1.492v1.272h-1.492v4.312c0 .67.299.983.956.983a5.24 5.24 0 0 0 .53-.037v1.264a4.473 4.473 0 0 1-.895.073c-1.588 0-2.208-.595-2.208-2.114v-4.481h-1.142v-1.272h1.142V16.44ZM85.837 22.205c0-1.688-.777-2.685-2.081-2.685-1.304 0-2.081 1.005-2.081 2.685 0 1.696.776 2.684 2.08 2.684 1.306 0 2.082-.988 2.082-2.684m-5.803 0c0-2.462 1.454-4.01 3.722-4.01s3.722 1.546 3.722 4.01c0 2.464-1.44 4.01-3.722 4.01s-3.722-1.54-3.722-4.01M88.806 18.293h1.536v1.331h.037a1.87 1.87 0 0 1 1.887-1.413c.186 0 .37.02.552.059v1.503a2.251 2.251 0 0 0-.724-.098 1.626 1.626 0 0 0-1.256.514 1.616 1.616 0 0 0-.426 1.286v4.64h-1.608ZM94.8 21.483h3.922a1.878 1.878 0 0 0-.527-1.412 1.89 1.89 0 0 0-1.397-.573 1.99 1.99 0 0 0-1.414.578c-.375.373-.585.88-.584 1.407m5.445 2.334c-.22 1.42-1.604 2.394-3.38 2.394-2.282 0-3.698-1.524-3.698-3.97s1.424-4.046 3.63-4.046c2.173 0 3.538 1.486 3.538 3.859v.55h-5.542v.098c-.051.582.15 1.158.554 1.582.403.424.97.655 1.556.633a1.776 1.776 0 0 0 1.816-1.098ZM37.163 11.734h.975c.488.03.964-.162 1.295-.522.33-.36.482-.849.41-1.332a1.622 1.622 0 0 0-.416-1.323 1.632 1.632 0 0 0-1.29-.52h-.974Zm1.065-4.426c1.535 0 2.433.94 2.433 2.561 0 1.647-.893 2.595-2.433 2.595h-1.869V7.308ZM44.456 10.517c0-.844-.38-1.338-1.046-1.338s-1.046.494-1.046 1.338c0 .843.377 1.34 1.046 1.34s1.046-.494 1.046-1.34m-2.888 0a1.842 1.842 0 0 1 .865-1.742 1.853 1.853 0 0 1 1.95 0c.597.37.932 1.044.865 1.742 0 1.261-.698 2.022-1.839 2.022-1.14 0-1.841-.76-1.841-2.022M50.141 12.464h-.798l-.807-2.867h-.06l-.804 2.867h-.792l-1.076-3.892h.781l.7 2.97h.058l.802-2.97h.738l.803 2.97h.062l.695-2.97h.77l-1.072 3.892ZM52.118 8.573h.74v.614h.058a1.17 1.17 0 0 1 1.164-.691 1.27 1.27 0 0 1 1.024.4c.262.282.382.668.325 1.048v2.52h-.767v-2.329c0-.624-.272-.936-.842-.936a.896.896 0 0 0-.932.986v2.278h-.77ZM56.66 7.053h.77v5.41h-.77ZM61.388 10.517c0-.844-.38-1.338-1.046-1.338s-1.046.494-1.046 1.338c0 .843.377 1.34 1.046 1.34.67 0 1.046-.494 1.046-1.34m-2.888 0a1.842 1.842 0 0 1 .865-1.742 1.853 1.853 0 0 1 1.95 0c.597.37.932 1.044.865 1.742 0 1.261-.698 2.022-1.839 2.022-1.14 0-1.841-.76-1.841-2.022M65.5 11.032v-.326l-.95.06c-.539.037-.781.22-.781.562 0 .343.304.555.723.555a.922.922 0 0 0 1.01-.851m-2.508.332c0-.7.523-1.104 1.452-1.162l1.056-.06v-.335c0-.411-.272-.644-.797-.644-.43 0-.732.157-.815.433h-.747c.079-.669.709-1.098 1.594-1.098.979 0 1.53.486 1.53 1.309v2.657h-.74v-.546h-.061a1.317 1.317 0 0 1-1.17.611 1.182 1.182 0 0 1-1.301-1.166M68.075 10.517c0 .826.391 1.322 1.044 1.322s1.05-.505 1.05-1.32c0-.814-.406-1.32-1.05-1.32s-1.044.499-1.044 1.319m-.795 0c0-1.23.633-2.01 1.62-2.01.498-.022.964.244 1.197.683h.058V7.053h.77v5.411h-.739v-.614h-.06c-.25.435-.721.696-1.224.678-.993 0-1.62-.779-1.62-2.012M77 10.517c0-.844-.38-1.338-1.046-1.338s-1.046.494-1.046 1.338c0 .843.377 1.34 1.046 1.34.67 0 1.047-.494 1.047-1.34m-2.889 0a1.842 1.842 0 0 1 .866-1.742 1.853 1.853 0 0 1 1.95 0c.596.37.932 1.044.865 1.742 0 1.261-.699 2.022-1.84 2.022-1.14 0-1.84-.76-1.84-2.022M78.825 8.573h.74v.614h.059a1.17 1.17 0 0 1 1.164-.691 1.27 1.27 0 0 1 1.024.399c.262.281.383.666.326 1.046v2.52h-.77v-2.326c0-.624-.272-.936-.841-.936a.896.896 0 0 0-.932.986v2.278h-.77ZM86.492 7.604v.987h.846v.647h-.846v2c0 .408.168.583.55.583.099 0 .196-.006.293-.018v.64a2.44 2.44 0 0 1-.419.04c-.857 0-1.198-.3-1.198-1.051V9.237h-.62V8.59h.62v-.986ZM88.39 7.053h.763v2.144h.06c.21-.46.686-.738 1.19-.696.382-.021.754.13 1.014.41.26.28.38.661.33 1.04v2.512h-.771v-2.321c0-.622-.293-.938-.834-.938a.913.913 0 0 0-.983.988v2.272h-.77ZM93.527 10.159H95.5a.938.938 0 0 0-.96-1.008.999.999 0 0 0-1.01 1.008m2.706 1.255a1.585 1.585 0 0 1-1.686 1.128c-1.12 0-1.804-.765-1.804-2.01 0-1.243.7-2.033 1.8-2.033 1.086 0 1.741.74 1.741 1.962v.268h-2.761v.044a1.026 1.026 0 0 0 1.038 1.115.938.938 0 0 0 .93-.472Z"
                />
              </svg> </a
            ><a
              class="store-icon store-icon-googleplay"
              href="https://play.google.com/store/apps/details?id=com.afripods.mobileapp&pli=1"
              ><span class="sr-only">Afripods on the Google Play Store</span>
              <svg height="35" width="117" xmlns="http://www.w3.org/2000/svg">
                <path
                  class="store-icon-background"
                  d="M0 31a4 4 0 0 0 4 4h109a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4Z"
                />
                <path
                  class="store-icon-content"
                  d="M50.426 18.518a3.61 3.61 0 0 0-3.589 3.626 3.61 3.61 0 0 0 3.609 3.606 3.61 3.61 0 0 0 3.598-3.616 3.575 3.575 0 0 0-1.046-2.577 3.55 3.55 0 0 0-2.572-1.039Zm0 5.812c-1.095 0-2.037-.904-2.037-2.192 0-1.289.948-2.195 2.037-2.195 1.088 0 2.035.891 2.035 2.195 0 1.303-.943 2.192-2.035 2.192ZM105.472 18.731l-1.813 4.611h-.055l-1.882-4.61h-1.705l2.822 6.445-1.608 3.585h1.65l4.35-10.03h-1.76ZM96.69 18.499c-1.137 0-2.332.506-2.823 1.629l1.405.588c.3-.588.86-.78 1.445-.78.818 0 1.65.493 1.664 1.368v.118a3.495 3.495 0 0 0-1.65-.41c-1.518 0-3.056.834-3.056 2.395 0 1.423 1.243 2.34 2.633 2.34 1.064 0 1.65-.479 2.018-1.04h.055v.822h1.528V21.44c0-1.888-1.405-2.942-3.218-2.942Zm-.189 5.829c-.518 0-1.242-.26-1.242-.904 0-.82.9-1.142 1.678-1.142a2.805 2.805 0 0 1 1.446.356 1.92 1.92 0 0 1-1.884 1.69ZM41.03 19.63v1.533h3.662c-.11.864-.396 1.494-.834 1.934-.533.535-1.366 1.124-2.828 1.124a4.08 4.08 0 0 1-3.984-4.084 4.08 4.08 0 0 1 3.984-4.085 3.894 3.894 0 0 1 2.76 1.096l1.079-1.083a5.323 5.323 0 0 0-3.839-1.549c-3.087 0-5.69 2.522-5.69 5.62 0 3.098 2.595 5.62 5.69 5.62 1.667 0 2.925-.549 3.907-1.576 1.01-1.015 1.328-2.44 1.328-3.591a4.997 4.997 0 0 0-.082-.952ZM86.87 14.9h-3.792v10.636h1.581v-4.03h2.21c1.754 0 3.478-1.273 3.478-3.302S88.625 14.9 86.871 14.9Zm.042 5.127h-2.25v-3.646h2.25a1.82 1.82 0 0 1 1.817 1.823 1.82 1.82 0 0 1-1.817 1.823ZM91.221 14.9h1.582v10.636h-1.582ZM58.323 18.518a3.61 3.61 0 0 0-3.589 3.626 3.61 3.61 0 0 0 3.609 3.606 3.61 3.61 0 0 0 3.598-3.616 3.575 3.575 0 0 0-1.046-2.577 3.55 3.55 0 0 0-2.572-1.039Zm0 5.812c-1.095 0-2.037-.904-2.037-2.192 0-1.289.948-2.195 2.037-2.195 1.088 0 2.035.891 2.035 2.195 0 1.303-.943 2.192-2.035 2.192ZM79.448 20.82c-.3-.808-1.216-2.302-3.086-2.302-1.87 0-3.402 1.467-3.402 3.616-.02.96.35 1.888 1.024 2.57a3.523 3.523 0 0 0 2.555 1.046 3.587 3.587 0 0 0 3.006-1.603l-1.22-.822c-.411.603-.971 1.001-1.777 1.001a1.833 1.833 0 0 1-1.749-1.096l4.814-1.998Zm-4.916 1.207a1.99 1.99 0 0 1 .501-1.452 1.975 1.975 0 0 1 1.384-.658c.63 0 1.163.316 1.34.761ZM70.61 14.9h1.586v10.636H70.61ZM68.016 19.329h-.055a2.501 2.501 0 0 0-1.897-.809c-1.803 0-3.457 1.59-3.457 3.633 0 2.042 1.654 3.604 3.457 3.604a2.462 2.462 0 0 0 1.897-.822h.055v.522c0 1.383-.738 2.123-1.927 2.123-.97 0-1.57-.698-1.817-1.288l-1.38.57A3.438 3.438 0 0 0 66.088 29c1.858 0 3.429-1.096 3.429-3.768v-6.495h-1.502Zm-1.817 5.003c-1.094 0-2.009-.917-2.009-2.18 0-1.26.915-2.207 2.009-2.207 1.094 0 1.925.933 1.925 2.208 0 1.275-.846 2.177-1.925 2.177ZM38.22 11.058c1.426 0 2.365-.828 2.365-2.577h-2.19v.571h1.418c-.044.83-.694 1.353-1.593 1.353-.5-.004-.976-.21-1.323-.571a1.874 1.874 0 0 1-.523-1.347 1.88 1.88 0 0 1 .528-1.339c.346-.358.82-.563 1.318-.57.443.003.871.168 1.202.465l.486-.465a2.46 2.46 0 0 0-1.688-.662 2.565 2.565 0 0 0-2.56 2.57 2.565 2.565 0 0 0 2.56 2.568ZM44.527 10.354h-2.353v-1.51h1.991V8.21h-1.991V6.613h2.281V5.98h-2.954v5.005h3.026v-.632ZM47.308 10.986V6.62h1.513v-.64h-3.708v.64h1.514v4.366h.68ZM51.378 5.98h.673v5.006h-.673ZM55.127 10.986V6.62h1.513v-.64h-3.705v.64h1.513v4.366h.679ZM61.391 11.058a2.56 2.56 0 0 0 2.394-1.56 2.576 2.576 0 0 0-.531-2.813 2.554 2.554 0 0 0-2.797-.571 2.57 2.57 0 0 0-1.586 2.38 2.541 2.541 0 0 0 .728 1.81 2.524 2.524 0 0 0 1.792.754Zm0-4.481c1.054 0 1.908.857 1.908 1.914a1.911 1.911 0 0 1-1.908 1.914 1.854 1.854 0 0 1-1.32-.563 1.867 1.867 0 0 1-.525-1.34c-.015-.502.172-.989.52-1.35a1.86 1.86 0 0 1 1.325-.574ZM65.636 7.216l2.272 3.77h.644V5.98h-.673v3.741l-2.251-3.741h-.666v5.005h.674v-3.77ZM20.398 16.579l3.287-3.298-12.102-6.893c-.557-.316-1.064-.36-1.447-.177ZM9.685 6.613a1.881 1.881 0 0 0-.254 1.014v18.802c-.012.33.061.658.212.951l10.325-10.362ZM28.104 15.8l-3.871-2.207-3.414 3.425 3.414 3.449 3.869-2.206c1.187-.681 1.187-1.787.002-2.46ZM20.396 17.445 10.062 27.812c.39.227.928.19 1.517-.137l12.106-6.902Z"
                />
              </svg>
            </a>
          </div>
        </div>
        <div class="bottom-content-wrapper-desktop">
          <div class="copyright">
            Copyright © {{ year }} Afripods AB. All rights reserved.<br />We improve our products and advertising by
            using Microsoft Clarity to see how you use our website.<br />By using our site, you agree that we and
            Microsoft can collect and use this data. Our
            <a href="https://afripods.africa/privacy-policy" target="_blank">privacy statement</a> and
            <a href="https://afripods.africa/cookie-policy" target="_blank">cookie policy</a> have more details.
          </div>
          <LoginButton v-if="!userLoggedIn" class="hide-on-mobile btn-black" />
        </div>
      </div>
    </div>

    <!--  we need to ensure this exists only once on each page, so put it in footer -->
    <div id="loginModal" class="modal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <LoginForm
            v-if="!userLoggedIn"
            :lt="loginType"
            :on-exit="closeLogin"
            :on-password-retrieval="closeLogin"
            @ltchange="updatelt"
          />
        </div>
      </div>
    </div>
    <div id="changeEmailModal" class="modal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <ChangeEmailForm />
        </div>
      </div>
    </div>
    <div id="changePasswordModal" class="modal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <ChangeForm />
        </div>
      </div>
    </div>
    <div id="retrievePasswordModal" class="modal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <RetrievePasswordForm />
        </div>
      </div>
    </div>
    <div id="promptModal" class="modal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="login-prompt">
            <div class="close-button">
              <a class="icon-close" @click.prevent="closePrompt"><span class="sr-only">Close</span></a>
            </div>
            <h2>Join Afripods!</h2>
            <p>You need to be logged in to use this feature.</p>
            <button
              class="button-arrow btn-orange btn"
              data-target="#loginModal"
              data-toggle="modal"
              @click="closePrompt"
            >
              I want to log in <i class="button-arrow-icon icon-arrow" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangeEmailForm from 'components/ChangeEmail'
import ChangeForm from 'components/ChangePassword'
import LoginButton from 'components/reused-components/login-button/LoginButton'
import LoginForm from 'components/reused-components/login-form/LoginForm'
import RetrievePasswordForm from 'components/reused-components/retrieve-password-form/RetrievePasswordForm'

export default {
  name: 'AfripodsFooter',
  components: {
    LoginButton,
    LoginForm,
    ChangeForm,
    ChangeEmailForm,
    RetrievePasswordForm,
  },
  props: {
    lt: {
      type: String,
      default: 'listener',
    },
    userLoggedIn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loginType: this.lt,
      year: new Date().getFullYear(),
    }
  },
  watch: {
    lt() {
      this.loginType = this.lt
    },
  },
  methods: {
    closeLogin() {
      $('#loginModal').modal('hide')
    },
    closePrompt() {
      $('#promptModal').modal('hide')
    },
    updatelt(type) {
      this.loginType = type
      this.$emit('ltchanged', type)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/reused-components/footer-section/FooterSection.vue